'use client';

import Link from 'next/link';
import { Logo } from '@puzzlio/ui';
import { Button } from '@puzzlio/ui';

export default function NotFound() {
  return (
    <div className="min-h-screen">
      <main className="flex flex-col items-center gap-8">
        <div className="flex flex-col items-center gap-2 pt-7 sm:pt-16 lg:pt-20">
          <h1>
            <Link href="/" className="inline-flex items-center text-black hover:text-gray-700">
              <Logo />
            </Link>
          </h1>
        </div>

        <div className="flex flex-col items-center gap-6 px-4 text-center">
          <h2 className="text-4xl font-bold">404 - Page Not Found</h2>
          <p className="text-lg text-gray-600">Oops! The page you're looking for doesn't exist.</p>
          <Link href="/">
            <Button variant="gameplay" color="red" size="gameplay">
              Return Home
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
